export default __webpack_public_path__ + "static/media/bg-pattern-home-6-about-5.d6ab17f2.svg";